import {Sex, UserIdentifier} from "../../../../constants"

export const activeSexPayload = (sex: Sex) => ({sex});
export const activeIdentifierPayload = (identifier: UserIdentifier) => ({identifier});
export const modalVisiblePayload = (visible: boolean) => ({visible});
